import React from "react";
import CustomButton from "shared/components/button/CustomButton";
import InputSearch from "shared/components/input/InputSearch";
import CustomModal from "shared/components/modal/CustomModal";

interface ModalVisualizarConcessionariasDisponiveisGroupPayProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const ModalVisualizarConcessionariasDisponiveisGroupPay: React.FC<
  ModalVisualizarConcessionariasDisponiveisGroupPayProps
> = (props) => {
  const renderContentModal = () => {
    return (
      <div>
        {renderTituloModal()}
        {renderBuscarConcessionarias()}
      </div>
    );
  };

  const renderTituloModal = () => {
    return <h2>Concessionárias disponíveis</h2>;
  };

  const renderBuscarConcessionarias = () => {
    return (
      <div className="campo-buscar-concessionarias-disponiveis">
        <InputSearch
          id="buscar-concessionarias-disponiveis"
          label="Buscar concessionária"
          placeholder="Buscar concessionária ou tipo serviço"
          onSearchChange={() => {}}
        />
      </div>
    );
  };

  const renderCustomFooter = () => {
    return (
      <CustomButton id="botao-fechar-modal-concessionarias-disponiveis" label="Fechar" onClick={props.onCloseModal} />
    );
  };
  return (
    <CustomModal
      onCloseModal={props.onCloseModal}
      showModal={props.showModal}
      tipoModal="MODAL_CENTRAL"
      size="lg"
      fecharModalAoClicarFora
      renderHeaderModal={false}
      customFooter={renderCustomFooter()}
    >
      {renderContentModal()}
    </CustomModal>
  );
};

export default ModalVisualizarConcessionariasDisponiveisGroupPay;
